import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  Error,
} from "components/Utils/Utils.js";

const metricFormatter = (cell, row, rowIndex, enumObject) => {
  const props = { ...cell, ...enumObject };
  return <MetricTable {...props} />;
};

class PocketWatchTableRevenue extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "date",
        text: "Date",
        hidden: true,

        sort: true,
      },
      {
        dataField: "month",
        text: "Month",
        style: {
          width: "80px",
          minWidth: "80px",
        },
        // headerStyle: () => {
        //   return { borderRight: "2px solid #C0C3C6", marginRight: 20 };
        // },
        csvFormatter: (cell) => cell && cell.value,
      },

      {
        dataField: "cpm",
        text: "CPM",
        style: { width: "60px", minWidth: "60px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "impressions",
        text: "IMPs",
        style: { width: "60px", minWidth: "60px" },
        formatter: metricFormatter,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "requests",
        text: "Requests",
        style: { width: "60px", minWidth: "60px" },
        formatter: metricFormatter,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "revenue",
        text: "Revenue",
        style: { width: "60px", minWidth: "60px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "date",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default PocketWatchTableRevenue;
